import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

export const EffectsRecordingComposition = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(513 / 60) * fps}
			style={{
				width: 1568,
				height: 1440,
				translate: '7.3px 33.5px',
			}}
		>
			<Video
				src={
					'https://remotion.media/explore-remotion/effects-source-2026-10-20-b764c2a283e9.mp4'
				}
				durationInFrames={(513 / 60) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						10, 20, 21, 23, 24, 26, 28, 29, 31, 32, 34, 35, 37, 38, 437, 444,
						445, 446, 447,
					],
					[
						'auto',
						'col-resize',
						'auto',
						'default',
						'auto',
						'pointer',
						'auto',
						'pointer',
						'auto',
						'pointer',
						'auto',
						'pointer',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'row-resize',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 87, 171, 241, 376, 480, 484],
						[
							4.510406088265163, 4.059365479438647, 4.510406088265163,
							4.059365479438647, 4.510406088265163, 4.059365479438647,
							4.510406088265163,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
							26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
							42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
							58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73,
							74, 75, 76, 77, 80, 81, 100, 101, 102, 103, 104, 105, 106, 107,
							108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120,
							121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133,
							134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146,
							147, 148, 149, 150, 151, 152, 153, 155, 156, 188, 189, 190, 191,
							192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204,
							205, 206, 207, 208, 209, 210, 211, 212, 213, 217, 218, 231, 232,
							233, 257, 258, 259, 260, 261, 262, 263, 265, 266, 267, 268, 269,
							270, 271, 272, 273, 274, 275, 276, 277, 278, 282, 283, 284, 285,
							286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298,
							299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311,
							312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324,
							325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337,
							338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 434,
							435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447,
							448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460,
							461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473,
							474, 475, 476, 477, 478, 479, 480,
						],
						[
							'-1412.373762709376px 2672.908932963013px',
							'-1378.5633358211696px 2650.356902521687px',
							'-1320.5270949823202px 2607.2261443026514px',
							'-1182.3430522078527px 2536.433911245427px',
							'-1018.5589311277239px 2431.126500348705px',
							'-874.5959305526667px 2316.075907550379px',
							'-548.613378032815px 2078.2576990370853px',
							'-338.45664435771005px 1898.3876374937295px',
							'-257.6745665659297px 1817.587940928167px',
							'-104.9197978735119px 1659.8118217077977px',
							'-25.776266043484114px 1555.3501119526252px',
							'19.292557291602943px 1487.6940206286476px',
							'49.13876007879507px 1427.9311399591343px',
							'81.99777318275808px 1352.1704126953055px',
							'91.2828669660227px 1300.6707369296842px',
							'104.23266569600275px 1257.4342660679547px',
							'112.86586484932279px 1214.1977952062255px',
							'120.84716937269825px 1177.9031212147167px',
							'128.82847389607372px 1141.608447223208px',
							'136.1578837895046px 1112.2555701019198px',
							'139.82258873622004px 1082.9026929806316px',
							'139.82258873622004px 1059.1702046958926px',
							'139.82258873622004px 1029.8173275746046px',
							'139.82258873622004px 1000.4644504533164px',
							'139.82258873622004px 964.1697764618077px',
							'139.82258873622004px 927.875102470299px',
							'136.14026501572232px 891.5804284787903px',
							'132.4579412952246px 855.2857544872816px',
							'128.77561757472685px 818.9910804957727px',
							'122.71475939362054px 800.878981047583px',
							'119.68433030306738px 782.7668815993932px',
							'113.62347212196107px 764.6547821512034px',
							'110.59304303140792px 750.8416635058913px',
							'107.56261394085476px 737.0285448605792px',
							'98.47132666919529px 709.8603956882946px',
							'89.39765817131811px 691.7482962401048px',
							'83.98869462015637px 677.9351775947928px',
							'79.23162569893921px 668.4210397523584px',
							'74.47455677772204px 658.906901909924px',
							'69.71748785650487px 649.3927640674898px',
							'67.3389533958963px 642.9090553156086px',
							'64.96041893528772px 636.4253465637274px',
							'63.23377910462371px 632.9720669023994px',
							'60.85524464401513px 626.4883581505183px',
							'59.12860481335112px 620.0046493986371px',
							'57.40196498268711px 616.5513697373091px',
							'57.40196498268711px 610.0676609854279px',
							'57.40196498268711px 603.5839522335467px',
							'55.675325152023106px 600.1306725722187px',
							'55.675325152023106px 593.6469638203375px',
							'55.675325152023106px 587.1632550684564px',
							'55.675325152023106px 580.6795463165752px',
							'55.675325152023106px 574.195837564694px',
							'55.675325152023106px 564.6816997222596px',
							'55.675325152023106px 558.1979909703784px',
							'55.675325152023106px 551.7142822184973px',
							'55.675325152023106px 540.473504545399px',
							'55.675325152023106px 533.9897957935178px',
							'55.675325152023106px 530.5365161321898px',
							'57.38434620890482px 527.0832364708617px',
							'57.38434620890482px 523.6299568095337px',
							'57.38434620890482px 520.1766771482057px',
							'57.38434620890482px 516.7233974868777px',
							'59.09336726578655px 514.9967576562137px',
							'59.09336726578655px 511.84299714918455px',
							'59.09336726578655px 510.11635731852056px',
							'59.09336726578655px 510.11635731852056px',
							'60.37953775189341px 508.8125680586314px',
							'60.37953775189341px 508.8125680586314px',
							'60.37953775189341px 507.64972898900055px',
							'60.37953775189341px 507.64972898900055px',
							'60.37953775189341px 507.0859282279674px',
							'60.37953775189341px 510.45111402038395px',
							'60.37953775189341px 520.0181081841652px',
							'60.37953775189341px 531.6993552018206px',
							'60.37953775189341px 545.4772362995682px',
							'60.37953775189341px 555.0618492371316px',
							'60.37953775189341px 567.7121288128128px',
							'60.37953775189341px 578.142442891926px',
							'60.37953775189341px 578.142442891926px',
							'60.37953775189341px 597.8930883018684px',
							'60.37953775189341px 607.7596016199484px',
							'60.37953775189341px 617.538021069117px',
							'60.37953775189341px 625.854082294356px',
							'60.37953775189341px 633.993955781772px',
							'61.55999559530656px 640.4776645336532px',
							'62.740453438719705px 650.6436970060321px',
							'62.740453438719705px 656.5283674493155px',
							'62.740453438719705px 664.3687217824327px',
							'62.740453438719705px 667.8924765388898px',
							'62.740453438719705px 679.4503921400693px',
							'62.740453438719705px 682.7979591587036px',
							'62.740453438719705px 691.2373518004185px',
							'64.37899940047228px 696.5934590302334px',
							'64.41423694803686px 701.7029034270962px',
							'64.41423694803686px 705.1738018622066px',
							'66.1056392311363px 708.59184397597px',
							'66.1056392311363px 711.6575106140878px',
							'66.75753386108087px 714.6703209308586px',
							'67.63847255019516px 720.5902289217066px',
							'67.76180396667115px 724.5896905702855px',
							'69.25939973816546px 729.5053284555432px',
							'69.45320624977059px 734.667629173753px',
							'69.45320624977059px 738.3499528942507px',
							'69.45320624977059px 741.9265639720547px',
							'70.29890739132031px 745.5031750498588px',
							'71.14460853287002px 751.98688380174px',
							'71.14460853287002px 755.4049259155033px',
							'71.14460853287002px 762.8224296778457px',
							'71.14460853287002px 766.2228530178269px',
							'71.14460853287002px 766.2228530178269px',
							'71.14460853287002px 771.4908663787303px',
							'71.14460853287002px 773.2527437569588px',
							'71.14460853287002px 773.2527437569588px',
							'71.14460853287002px 774.8560521711469px',
							'71.14460853287002px 774.8560521711469px',
							'71.14460853287002px 777.7102935238771px',
							'71.14460853287002px 781.1283356376406px',
							'71.14460853287002px 787.5768068419573px',
							'71.14460853287002px 791.4000807527133px',
							'71.14460853287002px 796.3861937331001px',
							'71.14460853287002px 800.1918488700738px',
							'71.14460853287002px 803.715603626531px',
							'71.14460853287002px 805.5127185523241px',
							'71.14460853287002px 805.5127185523241px',
							'71.14460853287002px 807.2569771567704px',
							'71.14460853287002px 807.2569771567704px',
							'71.14460853287002px 806.1646131822687px',
							'71.14460853287002px 788.052513734079px',
							'71.14460853287002px 764.3200254493399px',
							'71.14460853287002px 746.2079260011502px',
							'71.14460853287002px 722.4754377164112px',
							'71.14460853287002px 704.3633382682214px',
							'71.14460853287002px 686.2512388200316px',
							'74.1574188496409px 668.1391393718418px',
							'77.17022916641177px 650.0270399236521px',
							'80.18303948318264px 631.9149404754622px',
							'83.1958497999535px 613.8028410272724px',
							'86.86055474666895px 590.0703527425335px',
							'86.86055474666895px 576.2572340972214px',
							'89.87336506343983px 562.4441154519094px',
							'89.87336506343983px 552.929977609475px',
							'89.87336506343983px 546.4462688575939px',
							'91.58238612032154px 542.9929891962659px',
							'91.58238612032154px 539.5397095349379px',
							'91.58238612032154px 538.1125888585726px',
							'91.58238612032154px 536.8087995986835px',
							'91.58238612032154px 535.3816789223184px',
							'91.58238612032154px 533.6550390916543px',
							'93.29140717720327px 532.2279184152892px',
							'93.29140717720327px 530.5012785846252px',
							'93.29140717720327px 529.0741579082601px',
							'93.29140717720327px 529.0741579082601px',
							'93.29140717720327px 527.9289376124115px',
							'93.29140717720327px 527.9289376124115px',
							'93.29140717720327px 526.8189548641275px',
							'93.29140717720327px 525.4094529615446px',
							'93.29140717720327px 525.4094529615446px',
							'93.29140717720327px 525.9380161750132px',
							'93.29140717720327px 531.3117421786103px',
							'93.29140717720327px 537.8659260256206px',
							'93.29140717720327px 544.5082037415424px',
							'93.29140717720327px 548.2962401047339px',
							'93.29140717720327px 551.8376136349733px',
							'93.29140717720327px 551.8376136349733px',
							'93.29140717720327px 553.2647343113384px',
							'93.29140717720327px 554.4275733809693px',
							'93.29140717720327px 557.3170522812642px',
							'93.29140717720327px 560.7879507163744px',
							'93.29140717720327px 568.3464046689751px',
							'93.29140717720327px 568.3464046689751px',
							'93.29140717720327px 581.8247666124237px',
							'93.29140717720327px 588.555138197257px',
							'93.29140717720327px 593.5588699514261px',
							'93.29140717720327px 596.9769120651895px',
							'93.29140717720327px 600.0425787033072px',
							'93.29140717720327px 601.381605510761px',
							'93.29140717720327px 603.108245341425px',
							'93.29140717720327px 603.108245341425px',
							'93.29140717720327px 604.7467913031776px',
							'93.29140717720327px 608.0591207742473px',
							'93.29140717720327px 611.5300192093575px',
							'93.29140717720327px 614.948061323121px',
							'93.29140717720327px 620.6389252547993px',
							'93.29140717720327px 625.431231723581px',
							'93.29140717720327px 629.2192680867726px',
							'93.29140717720327px 632.7958791645765px',
							'93.29140717720327px 634.5753753165874px',
							'93.29140717720327px 637.9934174303509px',
							'93.29140717720327px 641.4290783178966px',
							'93.29140717720327px 645.0056893957005px',
							'93.29140717720327px 648.5118253783754px',
							'91.56476734653927px 651.9298674921389px',
							'90.70144743120726px 655.3479096059024px',
							'89.83812751587526px 660.1754536222486px',
							'89.16861411214839px 664.2806279135212px',
							'88.23481910168725px 667.9277140864544px',
							'87.37149918635525px 671.5043251642584px',
							'86.5610355923701px 673.2838213162693px',
							'85.59200303434437px 679.556104782763px',
							'84.55249538118952px 687.00884609267px',
							'82.82585555052552px 692.0654341681859px',
							'82.80823677674323px 696.9986908272259px',
							'82.80823677674323px 700.4167329409894px',
							'82.80823677674323px 703.1124053296791px',
							'81.39873487416037px 706.495209895878px',
							'81.0992157198615px 710.0189646523352px',
							'81.06397817229693px 711.7808420305637px',
							'81.02874062473236px 715.3398343345855px',
							'79.68971381727864px 718.7754952221312px',
							'79.68971381727864px 718.7754952221312px',
							'79.58400117458493px 721.9292557291603px',
							'79.58400117458493px 721.9292557291603px',
							'79.56638240080264px 723.3035200841787px',
							'79.54876362702035px 726.5101369125547px',
							'79.54876362702035px 729.1881905274621px',
							'79.54876362702035px 729.1881905274621px',
							'79.54876362702035px 732.2890947131444px',
							'79.54876362702035px 735.6190429579964px',
							'77.98069276039692px 738.9313724290662px',
							'77.85736134392091px 740.6932498072947px',
							'77.78688624879177px 742.3846520903942px',
							'77.7516487012272px 745.6265064663347px',
							'77.7516487012272px 745.6265064663347px',
							'77.71641115366263px 748.4983665928473px',
							'77.71641115366263px 750.0488186856885px',
							'76.16595906082148px 754.4182745836954px',
							'76.0250088705632px 756.1096768667948px',
							'75.91929622786948px 761.7829220246908px',
							'75.91929622786948px 763.2628990224028px',
							'75.24978282414261px 764.9895388530668px',
							'74.58026942041576px 766.6280848148194px',
							'74.45693800393975px 771.8608606281583px',
							'74.43931923015748px 773.6227380063868px',
							'74.42170045637519px 775.3846153846155px',
							'74.38646290881061px 778.4679007965154px',
							'73.6640931837369px 779.1726517478069px',
							'72.94172345866318px 779.73645250884px',
							'72.94172345866318px 781.0050042211647px',
							'72.94172345866318px 783.9473394428063px',
							'72.94172345866318px 787.4358566516989px',
							'72.94172345866318px 790.9772301819384px',
							'72.13125986467803px 792.7567263339492px',
							'71.21508362799918px 796.2980998641887px',
							'71.16222730665231px 799.8394733944281px',
							'71.14460853287002px 801.4251630348339px',
							'71.14460853287002px 801.4251630348339px',
							'68.9422618100843px 805.812237706623px',
							'36.04801115855673px 847.9739633676329px',
							'-37.950838727043596px 937.1954338011282px',
							'-222.0846435257124px 1131.618602488652px',
							'-367.3866709082233px 1260.2532698731204px',
							'-544.7196290269299px 1427.8959024115698px',
							'-722.0525871456364px 1586.5705790948357px',
							'-883.6519802767616px 1730.1988229680294px',
							'-1011.1590461391639px 1850.0417222351373px',
							'-1077.2294478227357px 1909.0998519533593px',
							'-1148.8673820215097px 1975.0645409942374px',
							'-1196.9842532209323px 2028.1146688526999px',
							'-1227.2533065788991px 2062.6827030135446px',
							'-1253.1881415864239px 2097.250737174389px',
							'-1278.8939325347787px 2137.562491588259px',
							'-1293.587989869205px 2166.8801311619827px',
							'-1304.6173422569161px 2196.1977707357064px',
							'-1308.2996659774137px 2210.8565905225682px',
							'-1316.9681026782985px 2268.716643623595px',
							'-1316.9681026782985px 2304.976080067539px',
							'-1316.9681026782985px 2304.976080067539px',
							'-1316.9681026782985px 2378.041134942678px',
							'-1316.9681026782985px 2421.242368256843px',
							'-1316.9681026782985px 2464.4436015710075px',
							'-1316.9681026782985px 2500.7030380149517px',
							'-1339.009188679938px 2544.679497375537px',
							'-1351.095667494586px 2562.756359276162px',
							'-1361.8959758231272px 2576.5342403739096px',
							'-1378.9509488443798px 2596.5667861643688px',
							'-1392.7640674896918px 2607.3318569453454px',
							'-1404.85054630434px 2622.3959085291995px',
							'-1412.6380443161104px 2636.173789626947px',
							'-1420.4255423278805px 2649.9516707246944px',
							'-1427.5611457097064px 2659.4305710195645px',
							'-1432.9701092608682px 2673.208452117312px',
							'-1437.7271781820853px 2682.6873524121816px',
							'-1442.4842471033023px 2692.166252707051px',
							'-1446.589421394575px 2698.614723911368px',
							'-1448.316061225239px 2702.0327660251314px',
							'-1450.042701055903px 2705.450808138895px',
							'-1451.769340886567px 2708.8688502526584px',
							'-1453.495980717231px 2715.3173214569747px',
							'-1455.222620547895px 2718.735363570738px',
							'-1456.949260378559px 2722.1534056845016px',
							'-1458.675900209223px 2722.1534056845016px',
							'-1459.3454136129499px 2722.1534056845016px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
